import useAppSelector from '../app/redux/useAppSelector';
import { UserType } from '../graphql/generated/graphql';
import authTokenUtil from './authTokenUtil';

function useIsLoggedIn() {
  return (
    useAppSelector(
      (state) =>
        !!state.session.user.id && state.session.user.type !== UserType.Visitor,
    ) || !!authTokenUtil.get()
  );
}

export default useIsLoggedIn;
